export enum BillUpdateType {
  NewRelatedBill = 'new_related_bill',
  NewBillAction = 'new_bill_action',
  NewAmendment = 'new_amendment',
  NewBillStatus = 'new_bill_status',
  NewBillTitle = 'new_bill_title',
  NewSponsor = 'new_sponsor',
  NewVersion = 'new_version',
  NewVoteOutcome = 'new_vote_outcome',
  NewCommitteeMention = 'new_committee_mention',
  RelatedHearings = 'related_hearings',
  HearingSoon = 'hearing_soon',
  NewMention = 'new_mention',
}

export interface BillDiffUpdateSummary {
  billDifferenceId: number;
  billId: string;
  // Empty when the change isn't one of the listed update types.
  updateTypes: BillUpdateType[];
  occurredAt: string;
  // The requesting user's workspaces the change is unread in; marking it read marks it
  // read for everyone in them.
  workspaceNames: string[];
}

export interface BillMentionUpdate {
  billAnnotationId: number;
  billId: string;
  annotationType: 'comment' | 'assignment';
  authorName: string;
  commentPreview: string | null;
  occurredAt: string;
}

export type BillUpdateIndicator = BillDiffUpdateSummary | BillMentionUpdate;

export interface BillUpdateSource {
  savedSearchId: string;
  savedSearchName: string;
  workspaceName: string;
}
